import { mutatorAction } from "satcheljs";

import { ImportJobsStore } from "../store/ImportJobsStore";

export const setImportJobInProgress =  mutatorAction("setImportJobInProgress", (inProgress: boolean) => {
    ImportJobsStore().jobInProgress = inProgress;
});